var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-list"},[(!_vm.loading)?_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.residents,"viewAction":'refresh-resident-dashboard',"title":"Past Residents"}}):_vm._e(),_vm._v(" "),_c('past-resident-detail')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3019fd87","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/person/past-residents/PastResidentList.vue
// module id = A6OW
// module chunks = 0 1